import { Component, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { RoutePlannerDataModel, AALocationModel } from '../../models/route-model';
import { RoutePlannerService } from '../../services/route-planner/route-planner.service';
import { RoutePlannerViaService } from '../../services/route-via/route-via.service';
import { AARoutePlannerEvents, RouteValidationMessage, MapContextMenuEvents } from 'src/app/core/events/events';
import { EventsService } from 'src/app/core/services/events.service';
import { AppError } from 'src/app/core/models/constants';
import { LocationManagerService } from '../../services/location-manager/location-manager.service';

@Component({
    selector: 'aa-route-via-list',
    templateUrl: './route-via-list.component.html',
    styleUrls: ['./route-via-list.component.scss'],
    standalone: false
})
export class RouteViaComponent implements OnInit, OnDestroy {

  public routeDataModel: RoutePlannerDataModel;
  public viaLocationMessage: string;
  public maxViaErrorMessage: string;

  constructor(
    private cdr: ChangeDetectorRef,
    private routePlannerService: RoutePlannerService,
    private routeViaService: RoutePlannerViaService,
    private eventsService: EventsService,
    private locationManager: LocationManagerService,
    private routePlannerViaService: RoutePlannerViaService) { }

  ngOnInit() {
    this.routeDataModel = this.routePlannerService.routeDataModel;

    this.eventsService.on(AARoutePlannerEvents.ADD_VIA_ROUTE, this.addViaRoute);
    this.eventsService.on(RouteValidationMessage.VIA_MESSAGE, this.viaMessageHandler);
    this.eventsService.on(RouteValidationMessage.MAX_VIA_MESSAGE, this.viaMaxMessage);
    this.eventsService.on(MapContextMenuEvents.UPDATE_VIA_LOCATION, this.updateDirection);
  }

  ngOnDestroy() {
    this.eventsService.remove(AARoutePlannerEvents.ADD_VIA_ROUTE, this.addViaRoute);
    this.eventsService.remove(RouteValidationMessage.VIA_MESSAGE, this.viaMessageHandler);
    this.eventsService.remove(RouteValidationMessage.MAX_VIA_MESSAGE, this.viaMaxMessage);
    this.eventsService.remove(MapContextMenuEvents.UPDATE_VIA_LOCATION, this.updateDirection);
  }

  get viaRouteList(): Array<AALocationModel> {
    return this.routeDataModel.ViaRoutes;
  }

  private viaMessageHandler = (viaLocation) => {
    this.viaLocationMessage = viaLocation;
  }

  private viaMaxMessage = () => {
    this.maxViaErrorMessage = '';
    this.apply();
  }

  private updateDirection = ( data: {locationModel: AALocationModel, index: number} ) => {

    this.routeViaService.validateLastViaRoute();
    let flag: boolean;

    if (data.index >= 0) {
      flag = this.routeViaService.updateViaLocationByIndex( data.locationModel, data.index );
    } else {
      flag = this.routeViaService.addViaLocation( data.locationModel );
    }

    if (flag) {
      this.maxViaErrorMessage = '';
      this.routePlannerService.updateGoogleMap();
    } else {
      this.maxViaErrorMessage = AppError.VIA_ROUTE_MAXIMUM;
    }
    this.apply();
  }

  apply() {
    setTimeout( () => {
      this.cdr.detectChanges();
    }, 10);
  }

  onFocus(locationModel) {
    this.viaLocationMessage = '';
    locationModel.clearPredictionList();
  }

  onBlurMethod(locationModel) {
    setTimeout(() => {
      locationModel.clearPredictionList(true);
    }, 100);
  }

  addViaRoute = (event: any, values: any) => {
    this.viaLocationMessage = '';
    // console.log('---', this.viaRouteList);

    if (this.routePlannerViaService.validateViaRoute()) {
      if (this.viaRouteList.length < this.routeViaService.getMaxRoute) {
        this.routeViaService.addViaRouteByName();
      } else {
        this.maxViaErrorMessage = AppError.VIA_ROUTE_MAXIMUM;
      }
    } else {
      this.viaLocationMessage = AppError.VIA_ROUTE_MISSING;
    }
    this.apply();
  }

  public onCloseViaBox(viaRoute: AALocationModel): void {
    this.viaLocationMessage = '';
    this.maxViaErrorMessage = '';
    this.routeViaService.removeViaRoute(viaRoute);
    this.apply();
  }

  selecteLocation(selectedItem, locationModel: AALocationModel) {
    if (selectedItem) {
      locationModel.Name = selectedItem.description;
    }
    locationModel.clearPredictionList();
  }

  getSelectVia($event, viaRoute: any) {
      if (viaRoute != null && $event.item !== undefined) { viaRoute.Name = $event.item.description; }
  }

  submitSearch() {
    this.eventsService.dispatch(RouteValidationMessage.MAX_VIA_MESSAGE, '');

    if (this.locationManager.fromLocation.Name === '' || this.locationManager.toLocation.Name === '') {
      this.eventsService.dispatch(RouteValidationMessage.FROM_TO_MESSAGE, AppError.ROUTE_LOCATION_MISSING);
      this.eventsService.dispatch(RouteValidationMessage.VIA_MESSAGE, AppError.ROUTE_LOCATION_MISSING);
      return;
    }
    if (this.locationManager.validateFromToLocation() && this.routePlannerViaService.validateViaRoute()) {
      this.routePlannerService.updateGoogleMap();
    } else {
      this.eventsService.dispatch(RouteValidationMessage.FROM_TO_MESSAGE, AppError.ROUTE_LOCATION_NOT_FOUND);
      this.eventsService.dispatch(RouteValidationMessage.VIA_MESSAGE, AppError.ROUTE_LOCATION_NOT_FOUND);
    }
  }
  
  trackByFn(index: number): number {
    return index;
  }
}


